import Vue from 'vue'
import { ValidationProvider, extend, configure } from 'vee-validate'
import { required } from 'vee-validate/dist/rules'

export default ({ app }) => {
  configure({
    // this will be used to generate messages.
    defaultMessage: (field, values) => {
      values._field_ = app.i18n.t(`fields.${field}`)
      return app.i18n.t(`validations.messages.${values._rule_}`, values)
    },
  })

  extend('required', {
    ...required,
  })

  Vue.component('ValidationProvider', ValidationProvider)
}
